import { useState } from "react";
import "../styles/formValidation.css";
import { isValidEmailAddress } from "../utils/emailValidation";

export function fieldValidationMessage(field: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement): string {
  const value = field.value.trim();
  if (field.required && !value) return "This field is required.";
  if (field instanceof HTMLInputElement && field.type === "email" && value && !isValidEmailAddress(value)) return "Enter a valid email address, such as name@example.com.";
  if (field.validity.rangeUnderflow) return `Enter a value of at least ${field.getAttribute("min")}.`;
  if (field.validity.rangeOverflow) return `Enter a value no greater than ${field.getAttribute("max")}.`;
  if (field.validity.stepMismatch) return "Enter a valid value using the allowed increments.";
  if (!field.validity.valid) return field.validationMessage;
  return "";
}
export default function useFormValidation() {
  const [errors, setErrors] = useState<Record<string, string>>({});
  const validate = (form: HTMLFormElement) => {
    const next: Record<string, string> = {};
    let first: HTMLElement | undefined;
    for (const field of Array.from(form.elements)) {
      if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement) || field.disabled || !field.willValidate) continue;
      const key = field.name || field.id;
      if (!key) continue;
      const message = fieldValidationMessage(field);
      if (message) { next[key] = message; first ||= field; }
    }
    setErrors(next); first?.focus();
    return Object.keys(next).length === 0;
  };
  const clearError = (key: string) => setErrors(previous => ({ ...previous, [key]: "" }));
  return { errors, validate, clearError };
}
